<template>
    <svg :width="`${width}px`" :height="`${height}px`" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <circle :fill="fill" cx="75" cy="75" r="75"/>
            <path stroke="#FFF" stroke-width="12" d="M40 72.318l24.737 24.737L109.792 52"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconCheckCircle",
    props: {
        width: {
            type: Number,
            default: 150
        },
        height: {
            type: Number,
            default: 150
        },
        fill: {
            type: String,
            default: '#E75300'
        },
    },
};
</script>
<style lang="scss">
    .bordered {
        border: 1px solid black;
        border-radius: 50%;
    }
</style>